import { componentMap as formComponentMap } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position/display-position';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'TextArea',
    formComponent: formComponentMap.CnInputTextArea,
    formItemBeforeHandler: (formItem) => {
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            if (componentProps) {
                componentProps.showLimitHint = true;
            }
        }
    },
    filterItemBeforeHandler: (filterItemProps, config) => {
        const { componentProps } = config || {};
        if (componentProps) {
            componentProps.showLimitHint = true;
        }
    },
};
